import { getPurchaseUrl } from '../config';
import { peekCheckoutGeo } from '../hooks/useCheckoutGeo';

function affiliateIds() {
  if (typeof localStorage === 'undefined') {
    return { affid: '', clickid: '' };
  }
  return {
    affid: localStorage.getItem('vpnnext_affid') || '',
    clickid: localStorage.getItem('vpnnext_clickid') || '',
  };
}

const SIGNUP_PASSWORD_KEY = 'vpn_signup_password';

export function stashSignupPassword(password) {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  if (password) {
    sessionStorage.setItem(SIGNUP_PASSWORD_KEY, password);
  } else {
    sessionStorage.removeItem(SIGNUP_PASSWORD_KEY);
  }
}

export function takeSignupPassword() {
  if (typeof sessionStorage === 'undefined') {
    return '';
  }
  const value = sessionStorage.getItem(SIGNUP_PASSWORD_KEY) || '';
  sessionStorage.removeItem(SIGNUP_PASSWORD_KEY);
  return value;
}

/**
 * Charge the selected plan through the Pages Function → Performanty gateway.
 */
export async function submitPurchase({ payment, email, plan }) {
  const geo = peekCheckoutGeo();
  const { affid, clickid } = affiliateIds();
  const response = await fetch(getPurchaseUrl(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      email,
      plan,
      userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
      firstName: payment.firstName,
      lastName: payment.lastName,
      cardNumber: payment.cardNumber,
      expiry: payment.expiry,
      cvv: payment.cvv,
      country: payment.countryCode,
      state: payment.regionCode || payment.regionName || '',
      postal: payment.postal,
      city: geo?.location?.city || '',
      affid,
      clickid,
    }),
  });

  const text = await response.text();
  if (!text) {
    return {
      ok: false,
      error: 'Empty response from server. Check function logs.',
    };
  }

  let data = {};
  try {
    data = JSON.parse(text);
  } catch {
    return { ok: false, error: 'Invalid response from server' };
  }

  if (!response.ok || data?.ok === false) {
    return {
      ok: false,
      error: data?.error || data?.result_msg || 'Payment failed',
      ...data,
    };
  }

  return { ok: true, ...data };
}
